import React from "react";
import DepositPageSection from "../sections/DepositPageSection/Content";

const DepositPage = () => {
  return <DepositPageSection />;
};

export default DepositPage;
